(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product"]) return;
  try {
    
  // Delegated, not wired per element: the theme editor re-renders the section
  // DOM on every setting tweak and would silently orphan a direct listener.
  document.addEventListener('change', (event) => {
    const select = event.target instanceof Element && event.target.closest('[data-pdp-variants]');
    if (!select) return;
    const root = select.closest('[data-loxord-section]');
    const price = root && root.querySelector('[data-atc-price]');
    const option = select.selectedOptions[0];
    if (price && option && option.dataset.price) price.textContent = option.dataset.price;
  });

  // Swatches drive the (hidden) select, which stays the form's truth — so
  // price updates and the submitted variant id share one path.
  document.addEventListener('click', (event) => {
    const swatch = event.target instanceof Element && event.target.closest('[data-pdp-swatch]');
    if (!swatch) return;
    const root = swatch.closest('[data-loxord-section]');
    const select = root && root.querySelector('[data-pdp-variants]');
    if (!select) return;
    const want = swatch.dataset.pdpSwatch;
    const option = [...select.options].find((o) => o.text.trim() === want || o.text.trim().startsWith(want));
    if (!option || option.disabled) return;
    select.value = option.value;
    select.dispatchEvent(new Event('change', { bubbles: true }));
    root.querySelectorAll('[data-pdp-swatch]').forEach((b) => {
      b.setAttribute('aria-current', b === swatch ? 'true' : 'false');
    });
  });

  } catch(e) { console.error(e); }
})();
})();
